import { render, staticRenderFns } from "./SimpleRegPopup.vue?vue&type=template&id=281ee0da&"
import script from "./SimpleRegPopup.vue?vue&type=script&lang=js&"
export * from "./SimpleRegPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports